import React from "react";
import { Convocatoria } from "../../../../../models/ConvocatoriasModel/convocatoria.model";
import { FechasConvocatoriaBannerShared } from "../../../../../components/Generales/FechasConvocatoriaBannerShared";

interface IProps {
  convocatorias: Convocatoria;
}

export const Banner: React.FC<IProps> = (props: IProps) => {
  return (
    <FechasConvocatoriaBannerShared
      convocatorias={props.convocatorias}
      variant="default"
    />
  );
};
